import memoize from 'lodash/memoize';
import md5 from 'blueimp-md5';

export const gravatar = memoize((email, size = 96) => {
  const hash = md5(email.trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?s=${size || 96}&d=404`;
});
